import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { DE$ } from '@infl-ts/util-datum';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import { logQueryError } from '@infl-ts/util-query-errors';
import * as DE from '@nll/datum/lib/DatumEither';
import { constVoid, flow, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as t from 'io-ts';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
var useGetProfileId = makeDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query GAProfileId {\n      profile {\n        id\n      }\n    }\n  "]))), t.type({
  profile: t.type({
    id: t.string
  })
}));

var useProps = function useProps(_ref) {
  var analyticsConfig = _ref.analyticsConfig;
  return {
    profileId: pipe(useGetProfileId(), DE.map(function (_ref2) {
      var profile = _ref2.profile;
      return profile.id;
    }), DE$.getSuccessOrElse(null)),
    analyticsConfig: analyticsConfig
  };
};

var GoogleAnalyticsInitializer = function GoogleAnalyticsInitializer(_ref3) {
  var analyticsConfig = _ref3.analyticsConfig,
      profileId = _ref3.profileId;
  useEffect(function () {
    pipe(analyticsConfig, DE.map(O.chainNullableK(function (obj) {
      return obj.googleAnalyticsTrackingId;
    })), DE.squash(constVoid, flow(logQueryError, constVoid), O.match(constVoid, function (googleAnalyticsTrackingId) {
      ReactGA.initialize(googleAnalyticsTrackingId);
      ReactGA.set({
        user_id: profileId
      });
    })));
  }, [analyticsConfig, profileId]);
  return null;
};

export var GoogleAnalytics = flow(useProps, GoogleAnalyticsInitializer);